import styled from 'styled-components/macro';
import { TABLET_BREAKPOINT } from '../../app/constants';

export const StyledRightSidebar = styled.div`
  padding-left: 2rem;
  position: relative;
  transition: 0.2s;
  display: flex;
  flex-direction: column;
  @media (max-width: ${TABLET_BREAKPOINT}px) {
    display: none;
  }
`;
